require('jquery')

if(parent.frames.length > 0) {
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    var thisSiteHeight = $('body').height()+200;
    var id, eventSource, eventOrigin;

    eventer(messageEvent, function(event) {
      eventSource = event.source;
      eventOrigin = event.origin;

      var data = event.data;
      if(!data || data.length === 0) {
        return;
      }

      data = data.split('-');
      if(data.length !== 2) {
        return;
      }

      if(data[0] !== 'height') {
        return;
      }

      id = parseInt(data[1], 10);
      if(isNaN(id)) {
        return;
      }
      eventSource.postMessage(id + '-' + thisSiteHeight + '-' + 0, eventOrigin);

      function resize() {
        if(window.self != window.top) {
          var thisSiteHeight = $('body').height()+400;
          setTimeout(function(){  eventSource.postMessage(id + '-' + thisSiteHeight, eventOrigin); }, 1000);
          console.log("test: " + thisSiteHeight);
        }
      }
      function resize_butt() {
        if(window.self != window.top) {
          var thisSiteHeight = $('body').height() + 70;
          setTimeout(function(){  eventSource.postMessage(id + '-' + thisSiteHeight + '-' + 0, eventOrigin); }, 200);
        }
      }
	
      $(window).resize(function() {
        resize();
      });

      $(document).ready(function() {
        resize();
      });
    }, false);
}